import { Award, Clock, Eye } from 'lucide-react';

const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_werbetechnik-landing/artifacts/g53wqtcm_34654907-f452-402e-8e72-6a75d482ff8b.jpeg";

const values = [
  {
    icon: Award,
    title: "Qualität",
    description: "Wir verwenden ausschließlich hochwertige Materialien führender Hersteller."
  },
  {
    icon: Clock,
    title: "Schnelle Lieferung",
    description: "Ihre druckfertigen Designs und Folien erhalten Sie zügig per Versand."
  },
  {
    icon: Eye,
    title: "Detailgenauigkeit",
    description: "Jedes Design wird mit höchster Präzision und Sorgfalt erstellt."
  }
];

export const About = () => {
  return (
    <section
      id="ueber-uns"
      className="py-24 lg:py-32 bg-slate-900 text-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={ABOUT_IMAGE}
                alt="AKW Design Werkstatt"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Accent */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-600 rounded-2xl -z-10" />
          </div>

          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-teal-600/20 text-teal-400 text-sm font-semibold rounded-full mb-6">
              ÜBER UNS
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-6">
              Über AKW Design
            </h2>
            <p className="text-lg text-slate-300 mb-6 leading-relaxed">
              AKW Design steht für professionelle Werbetechnik-Designs aus Weilburg. Mit Leidenschaft für Gestaltung und einem Auge für Details verwandeln wir Ihre Ideen in druckfertige Lösungen.
            </p>
            <p className="text-slate-400 mb-10 leading-relaxed">
              Ob Fahrzeugdesign, Schaufenstergestaltung oder individuelle Sticker – bei uns bekommen Sie kreative Konzepte und hochwertige, selbstklebende Folien. Wir gestalten und produzieren, Sie oder Ihr Fachbetrieb bringen es an.
            </p>

            {/* Values */}
            <div className="space-y-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="flex gap-4"
                  data-testid={`about-value-${index}`}
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-teal-600/20 rounded-xl flex items-center justify-center">
                    <value.icon className="w-6 h-6 text-teal-400" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1">
                      {value.title}
                    </h3>
                    <p className="text-slate-400">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
